import CheckIcon from "@mui/icons-material/Check";
import { TableCell, TableRow, Typography } from "@mui/material";

import { CarrierShipmentProgressStatusBadge } from "components/CarrierShipmentProgressStatusBadge";
import { buildCarrierProfileUrl } from "components/CompanyProfile/utils";
import { NewTabLink } from "components/NewTabLink";
import { CarrierProfileSource } from "constants/index";

import {
  AddCarrierToNetworkButton,
  FollowShipperRequestSource,
} from "../../AddCarrierToNetworkButton";

interface Props {
  carrierProgress: CarrierShipmentProgress;
  followShipperRequestsSent: FollowShipperRequestAndResponse[] | null;
}

export function ShipmentProgressDetailTableRow(props: Props) {
  const { carrierProgress, followShipperRequestsSent } = props;

  const getUserColumnText = () =>
    `${carrierProgress?.carrier?.user?.first_name || ""} - ${carrierProgress?.carrier?.company?.name || ""}`;
  return (
    <TableRow key={carrierProgress.carrier.user.id}>
      <TableCell>
        <Typography variant="body1">
          {carrierProgress?.carrier?.company ? (
            <NewTabLink
              href={buildCarrierProfileUrl(
                carrierProgress.carrier.company.id,
                CarrierProfileSource.SHIPMENT_PROGRESS_DETAIL,
              )}
            >
              {getUserColumnText()}
            </NewTabLink>
          ) : (
            getUserColumnText()
          )}
        </Typography>
      </TableCell>
      <TableCell>
        {carrierProgress.is_partner ? (
          <CheckIcon />
        ) : (
          <AddCarrierToNetworkButton
            carrierId={carrierProgress.carrier.id}
            source={FollowShipperRequestSource.SHIPMENT_PROGRESS_DETAIL}
            checkForRequestAlreadySent={false}
            sentRequests={followShipperRequestsSent}
          />
        )}
      </TableCell>
      <TableCell>
        <CarrierShipmentProgressStatusBadge
          status={carrierProgress.status}
          size="small"
        />
      </TableCell>
    </TableRow>
  );
}
